// 定数クラス
export default {
  // APIに関わるもの
  API: {
    STATUS_OK: 200, // API結果OK
    FAIL_BAD_REQUEST: 400, // Bad Request
    FAIL_BEFORE_CHARGE: 510, // 購入失敗(未決済)
    FAIL_AFTER_CHARGE: 511, // 購入失敗(決済済)
  },
  // ActionCableに関わるもの
  ACTION_CABLE: {
    DEFAULT: 0, // 初期値
    CONNETED: 1, // 接続済み
    DIS_CONNECTED: 2, // 切断
    NON_TARGET: 3, // 対象外
  },
  // アーティスト別イベント一覧に関わるもの
  PERFORMER_EVENTS: {
    PER_PAGE_EVENTS_NUM: 10, // 1ページ辺りの件数
  },
  // 出演者フォローステータス
  PERFORMER_FOLLOW_STATUS: {
    DEFAULT: 0, // 初期値
    FOLLOWABLE: 1, // フォロー可能
    UN_FOLLOWABLE: 2, // フォロー解除
    NO_LOGGEDIN: 3, // 未ログイン
  },
  // ライブチャットに関わるもの
  EVENT_LIVE_CHAT: {
    PARENT_COLLECTION: 'liveChat', // 親collection名
    CHILD_COLLECTTION: 'messages', // 子collection名
  },
  // 投げ銭に関わるもの
  EVENT_LIVE_DONATION_STSTUS: {
    BEFORE_DONATION: 0, // 投げ銭前or未投げ銭
    DONATING: 1, // 投げ銭(決済)中
    BEFORE_LISTING: 2, // 投げ銭後、一覧表示前
    DONE_DONATION: 3, // 一覧表示完了
    FAIL_BEFORE_CHARGE: 10, // 投げ銭失敗(未決済)
    FAIL_AFTER_CHARGE: 11, // 投げ銭失敗(決済済)
    FAIL_ADD_FIRE_BASE: 12, // Firebase失敗
    PARENT_COLLECTION: 'liveDonation', // 親collection名
    CHILD_COLLECTTION: 'donatedItems', // 子collection名
  },
  // 幕に関わるもの
  EVENT_LIVE_CURTAIN: {
    PARENT_COLLECTION: 'liveCurtain', // 親collection名
    CHILD_COLLECTTION: 'dispFlg', // 子collection名
  },
  // 主催者コメントに関わるもの
  EVENT_LIVE_EVENTER_COMMENT: {
    PARENT_COLLECTION: 'liveEventerComment', // 親collection名
    CHILD_COLLECTTION: 'comments', // 子collection名
  },
  // 同時視聴に関わるもの
  EVENT_LIVE_MULTIPLE_VIEWING: {
    PARENT_COLLECTION: 'liveMultipleViewing', // 親collection名
    CHILD_COLLECTTION: 'viewerIds', // 子collection名
  },
  // 通し券イベントの参加者リストに関わるもの
  PAY_STATUS: {
    PAID: 'paid',
    BEFORE_PAID: 'before_paid',
    CANCELED: 'canceled',
  },
  PAY_METHOD: {
    CREDIT_CARD: 'credit_card',
    CVS: 'cvs',
  },
  // 通報に関わるもの
  PUNISH_TYPE: {
    BLOCK: '1',
    NON_BLOCK: '0',
  },
  ALL_CANCEL: {
    YES: 'yes',
    NO: '',
  },
};
